import { Box, LssProp } from '@lucidhq/lucidium';

export interface DividerProps {
  lss?: LssProp;
}

export const Divider = ({ lss }: DividerProps) => (
  <Box
    lss={{
      flexShrink: 0,
      borderWidth: 0,
      borderStyle: 'solid',
      borderColor: 'gray600',
      borderBottomWidth: 'thin',
      ...lss,
    }}
  />
);

Divider.displayName = 'Divider';
